import React, {memo, useEffect, useState} from "react";
import {Head, BlogEditSeo, BlogEditCategory, BlogBasicInfo, ModelUploader} from "../../components";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import {connect} from "react-redux";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from '@mui/material/StepButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Paper} from '@mui/material'
import HeadLine from "../../components/HeadLine/headLine";
import {useParams} from "react-router-dom";

const actions = [
    { name: 'اطلاعات اولیه', 'step' : 0 },
    { name: 'محتویات و سئو', 'step' : 1 },
    { name: 'دسته بندی', 'step' : 2 },
    { name: 'گالری تصاویر', 'step' : 3 },
];

const ContentUpdateOrCreate = memo((props) => {

    
    const { id, slug } = useParams();
    

    const [step, setStep] = useState(0);
    const [contentID, setContentID] = useState(id ? id : null);

    const switchStep = () => {
        switch (step) {
            case 0:
                return (<BlogBasicInfo contentID={contentID} onComplete={(contentID) => {
                    setContentID(contentID);
                    setStep(step + 1);
                }}/>);
                break;
            case 1:
                return (<BlogEditSeo contentID={contentID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 2:
                return (<BlogEditCategory contentID={contentID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 3:
                return (<ModelUploader model={'content'} entityID={contentID}/>);
                break;

        }
    };


    const handleChangeTab = (event, newValue) => {
        setStep(newValue);
    };

    return(
        <Container>
            {

                <HeadLine
                    link={`https://digiattar.com/blog/post/${id}`}
                    title={slug}
                    subTitle={"مراحل را جهت ایجاد و یا ویرایش محصول طی کنید."}
                />
            }
            <Box mt={5}>
                {!id ? <Stepper elevation={1} alternativeLabel activeStep={step}>
                    {actions.map((item, index) => {
                        return(<Step key={item.step}>
                            <StepButton onClick={() => {
                                if (contentID) {
                                    setStep(item.step)
                                }
                            }}>
                                <StepLabel>
                                    <span>{item.name}</span><br/>
                                </StepLabel>
                            </StepButton>
                        </Step>);
                    })}
                </Stepper> : <Paper>
                    <Tabs
                        value={step}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        {actions.map((item) => {
                            return(
                                <Tab label={item.name} />
                            );
                        })}

                    </Tabs>
                </Paper>}
                {switchStep()}
            </Box>
        </Container>
    );
})

const mapStateToProps = state => ({
    authReducer : state.authReducer
})


export default connect(mapStateToProps)(ContentUpdateOrCreate);